import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import axios from "axios";

function FaceMatch() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    sign_label: "",
    remark: "",
    status: "",
  });
  const [values, setValues] = useState({ DocImage: "", SelfieImage: "" });
  const [loading , setLoading] = useState(true);

  useEffect(() => {
    console.log(cardData);
  }, [cardData]);

  const onChange = (e) => {
    const { name, value } = e.target;
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);

      const formField = {
        ...values,

        [name]: base64String,
      };
      setValues(formField);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setCardData({
      Document_type: "",
      face_match: "",
      confidence_score: "",
      face_count: "",
    });
    // var data = new FormData();
    // data.append('DocImage', values.DocImage)
    // data.append('SelfieImage', values.SelfieImage)
    var config = {
      method: "post",
      url: "https://7izf2fny08.execute-api.ap-south-1.amazonaws.com/default/facematchservice",
      headers: {
        "x-api-key": "jCSIISHVNG2e3QLKbX0P82l6LyFM4oLj3mAyUH5R",
        authorizationToken: "7Qeb3IoX5pxc214L",
      },
      data: values,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
      })
      .catch(function (error) {
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div>
        <div>
          <div class="container containerBoreder " id="pan">
            <h2 class="pageTitle">Face Match</h2>
            <div class="row">
              <div class="col-4">
                <input type="file" name="DocImage" onChange={onChange} />
               
              </div>
              <div class="col-4">
            <input type="file" name="SelfieImage" onChange={onChange} />
              </div>
              <div class="col-4">
                <button class="btn btn-primary" type="submit" onClick={submit}>
                  Submit
                </button>
              </div>
            </div>
            <br />
            <table class="table">
              <tbody>
                <tr>
                  <td>
                    {values.DocImage ? (
                      <img
                        style={{
                          backgroundColor: "#44014C",
                          width: "300px",
                          minHeight: "200px",
                        }}
                        alt=""
                        className="image"
                        src={"data:image/png;base64," + values.DocImage}
                      ></img>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {values.SelfieImage ? (
                      <img
                        style={{
                          backgroundColor: "#44014C",
                          width: "150px",
                          minHeight: "200px",
                        }}
                        alt=""
                        src={"data:image/png;base64," + values.SelfieImage}
                      ></img>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>

                <tr>
                  <th>Face match</th>
                  <td>{cardData.face_match}</td>
                </tr>
                <tr>
                  <th>Confidence Score</th>
                  <td>{cardData.confidence_score}</td>
                </tr>
                <tr>
                  <th>Face Count</th>
                  <td>{cardData.face_count}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaceMatch;
